// extracted by mini-css-extract-plugin
module.exports = {"yotpoReviewExtender":"ReviewPage_yotpoReviewExtender__JeJ_I","yotpoReviewContainer":"ReviewPage_yotpoReviewContainer__N_dQ2"};